
        var result = require("!!../../../../node_modules/css-loader/index.js!./treatment-subsalesgroup.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-base/treatment-subsalesgroup.component.css
// module id = 2388
// module chunks = 1